import ParamBanque from "@/components/parametres/parametre/param-banque";
// Page Banque (04/10/2026). Les anciens onglets Sociétés et Exclusions (composants assurance-societes et
// custom_exclusions, gardés dans le code) sont remplacés par Clinique › Paramètres › Assurances & Conventions.

export default {
    name: 'parametre',
    components: {
        ParamBanque
    },
}
